module.exports = __webpack_public_path__ + "static/media/摄图网_6.aed669e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/摄图网_6.png
// module id = 1710
// module chunks = 0